import {Autocomplete, FormControl, TextField, Grid} from '@mui/material';
import React, { useState, useEffect, Fragment } from 'react';
import {useTranslation} from "react-i18next";
import {useGlobalStorage} from '../mobx/GlobalStorage.js';
import {TT_SPEC, TT_SUBSPEC} from '../Util.js'
import {TAB_SPECIES} from './SearchCommon.js';
import {getSpecName} from '../Trans.js'

function FilterSpec(props) {
	const {t} = useTranslation('obs');
	const gStorage = useGlobalStorage();
	const [specList, setSpecList] = useState([]);

	useEffect(() => {
		let _sl = [];

		if (gStorage.lists.speclist && gStorage.lists.speclist.list) {
			_sl = gStorage.lists.speclist.list.filter(x => (x.t_type === TT_SPEC || x.t_type === TT_SUBSPEC) && x.visible === 1).sort(taxonSort);
		}

		setSpecList(_sl);
		// eslint-disable-next-line
	}, []);

	function searchGetSpecName(spec) {
// 		console.log('searchGetSpecName', spec);
		return getSpecName(spec, gStorage.conn.user);
	}

	function taxonSort(t1, t2) {
	 	return searchGetSpecName(t1).localeCompare(searchGetSpecName(t2), 'fi');
	}

	/* ------------------------------------------------------------------ */

	if (gStorage.main.filter.tab !== TAB_SPECIES)
		return null;

	return(
		<Fragment>
			<Grid size={{xs: 12}} align={'center'}>
				<FormControl variant="outlined" style={{width: 300, margin: 8}}>
					<Autocomplete
						multiple
						size='small'
						onChange={props.specChange}
						options={specList}
						getOptionLabel={(dt) => searchGetSpecName(dt)}
						isOptionEqualToValue={(dt, val) => dt.id === val.id}
						defaultValue={[]}
						value={props.filter.species}
						filterSelectedOptions
						renderInput={(params) => (
							<TextField
								{...params}
								label={t('filter.species')}
							/>
						)}
					/>
				</FormControl>
			</Grid>
		</Fragment>
	);
};

export default FilterSpec;
